import { Box, Button, FormField, Input, Modal, Select, SelectProps, SpaceBetween } from '@amzn/awsui-components-react';
import { Fragment, ReactNode, useEffect, useState } from 'react';

import { constants } from '../../../common/Localization';
interface DeleteAttributeModalProp {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    deleteAttributeOptions: SelectProps.Options;
    onConfirmDeleteAttribute: (attributeName?: string) => Promise<void>;
}

const DeleteAttributeModal = (props: DeleteAttributeModalProp): JSX.Element => {
    const [selectedAttr, setSelectedAttr] = useState<SelectProps.Option | null>(null);
    const [inputValue, setInputValue] = useState('');
    const [errorMsg, setErrorMsg] = useState<ReactNode>('');

    useEffect(() => {
        const DefaultErrorMsg = (
            <Fragment>
                {constants.DELETE_ATTRIBUTE_CONFIRM_ERROR_1} <em> {constants.DELETE_ATTRIBUTE_CONFIRM_INPUT} </em> {constants.DELETE_ATTRIBUTE_CONFIRM_ERROR_2}
            </Fragment>
        );
        if (inputValue !== constants.DELETE_ATTRIBUTE_CONFIRM_INPUT && inputValue.length > 0) {
            setErrorMsg(DefaultErrorMsg);
        } else {
            setErrorMsg('');
        }
    }, [inputValue]);

    const dismissModal = () => {
        setSelectedAttr(null);
        setInputValue('');
        props.setVisible(false);
    };
    const onConfirm = () => {
        props.onConfirmDeleteAttribute(selectedAttr?.value);
        dismissModal();
    };
    const HintMsg = (
        <Fragment>
            {constants.DELETE_ATTRIBUTE_CONFIRM_HINT_1} <em> {constants.DELETE_ATTRIBUTE_CONFIRM_INPUT} </em> {constants.DELETE_ATTRIBUTE_CONFIRM_HINT_2}
        </Fragment>
    );

    const invalidDeletion = (): boolean => {
        if (!selectedAttr) {
            return true;
        }
        return inputValue !== constants.DELETE_ATTRIBUTE_CONFIRM_INPUT;
    };
    return (
        <Modal
            onDismiss={dismissModal}
            visible={props.visible}
            size="medium"
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={dismissModal}>{constants.CANCEL_BUTTON_TEXT}</Button>
                        <Button variant="primary" onClick={onConfirm} disabled={invalidDeletion()}>
                            {constants.DELETE_BUTTON_TEXT}
                        </Button>
                    </SpaceBetween>
                </Box>
            }
            header={constants.DELETE_ATTRIBUTE_MODAL_HEADER}
        >
            <SpaceBetween size="xxl" direction="vertical">
                <SpaceBetween size="s" direction="vertical">
                    <Box>{constants.DELETE_ATTRIBUTE_NOTES}</Box>
                    <FormField label={constants.DELETE_ATTRIBUTE_FORM_LABEL}>
                        <Select
                            options={props.deleteAttributeOptions}
                            selectedOption={selectedAttr}
                            onChange={({ detail }) => setSelectedAttr(detail.selectedOption)}
                        />
                    </FormField>
                </SpaceBetween>
                <FormField label={HintMsg} errorText={errorMsg}>
                    <Input value={inputValue} onChange={({ detail }) => setInputValue(detail.value)} />
                </FormField>
            </SpaceBetween>
        </Modal>
    );   
};

export default DeleteAttributeModal;
